export const DEFAULT_MODAL_ZINDEX = 1000;
export const MODAL_ANIMATION_DURATION_MS = 300;
export const MODAL_TOP_OFFSET = 80;
export const MODAL_TOP_OFFSET_MOBILE = 48;
export const MODAL_Z_INDEX = 15;
export const MODAL_BORDER_RADIUS = 8;
export const MODAL_PADDING = 24;
export const MODAL_PADDING_MOBILE = 12;
export const HEADER_MIN_HEIGHT = 78;
export const HEADER_MIN_HEIGHT_MOBILE = 56;
export const HEADER_PADDING = 24;
export const HEADER_PADDING_MOBILE = 16;
export const HEADER_TITLE_WRAPPER_GAP = 4;
export const BODY_PADDING = 24;
export const BODY_PADDING_MOBILE = 16;
export const FOOTER_MIN_HEIGHT = 68;
export const FOOTER_PADDING_VERTICAL = 16;
export const FOOTER_PADDING_HORIZONTAL = 24;
export const FOOTER_PADDING_MOBILE = 16;
export const FOOTER_BORDER_RADIUS = 8;
export const FOOTER_GAP = 16;
export const FOOTER_GAP_MOBILE = 8;
